// extracted by css-extract-rspack-plugin
export default {"container":"Rz8rPv3ZDNQaDbgX","header":"pTDL7RHiCE4ranPs","heading":"vtaGIOT_FE8CU9rX","addFile":"GpMg_MGciK4_rjWd"};